export const drawingMaterialTypes = [
  {
    label: 'Drawing Paper',
    value: 'Drawing Paper',
  },
  {
    label: 'Drafting Film or Mylar',
    value: 'Drafting Film or Mylar',
  },
  {
    label: 'Fluorescent Background',
    value: 'Fluorescent Background',
  },
  {
    label: 'Digital Displays',
    value: 'Digital Displays',
  },
  {
    label: 'Ink and Markers',
    value: 'Ink and Markers',
  },
  {
    label: 'Watercolor or Rendering Mediums',
    value: 'Watercolor or Rendering Mediums',
  },
  {
    label: 'Adhesive Films or Decals',
    value: 'Adhesive Films or Decals',
  },
];
